/**
 * ExpandableContent.tsx — Generic height-collapsible wrapper used by
 * `MarkdownTextPanel` to implement "Show more / Show less" truncation.
 *
 * **Not a direct CMS JSON component** — rendered programmatically by
 * `MarkdownTextPanel` when `options.minHeight` is set.
 *
 * **Props:**
 *  - `maxHeight`  — Collapsed height in px. Content is clipped at this height
 *    with a CSS `overflow: hidden` and a gradient fade-out overlay.
 *  - `children`   — Any React nodes to truncate.
 *  - `props`      — Passed through `ComponentRenderProps` for future extensibility.
 *
 * **Toggle:** A "Show more" / "Show less" link below the container toggles
 * `expanded` state and removes the height constraint.
 */
import React, { useState } from "react";
import { ComponentRenderProps } from "./index";

const ExpandableContent: React.FC<{ maxHeight: number; children: React.ReactNode, props: ComponentRenderProps }> = ({ children, maxHeight, props }) => {
    const [expanded, setExpanded] = useState(false);

    const toggleExpand = () => {
        setExpanded(!expanded);
        if (expanded && wrapperRef.current) {
            //wrapperRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [showExpanderLink, setShowExpanderLink] = useState(false);
    const contentRef = React.useRef<HTMLDivElement>(null);
    const wrapperRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (contentRef.current) {
            setShowExpanderLink(contentRef.current.scrollHeight > maxHeight);
        }
    }, [maxHeight, children]);

    return (
        <div style={{ border: '0px solid red' }} id="expanderWrapper" ref={wrapperRef}>
            <div
                id="expanderContent"
                ref={contentRef}
                style={{
                    maxHeight: expanded ? `${contentRef.current?.scrollHeight}px` : `${maxHeight}px`,
                    overflow: 'hidden',
                    transition: 'max-height 0.5s ease-in-out',
                }}
            >
                {children}
            </div>
            {showExpanderLink && (
                <div
                    id="expanderLink"
                    style={{
                        textAlign: 'right',
                    }}
                >
                    <a
                        onClick={toggleExpand}
                        style={{
                            cursor: 'pointer',
                            color: 'black',
                            fontWeight: 'bold',
                            textDecoration: 'none',
                        }}
                    >
                        {expanded ? '...Less -' : '... More +'}
                    </a>
                </div>
            )}
        </div>
    );
};
export default ExpandableContent;
